"use strict";

import React from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import classNames from "classnames";
import { observer } from "mobx-react";
export var StepCount = observer(function (_ref) {
  var currentStep = _ref.currentStep,
    totalSteps = _ref.totalSteps,
    goToAPreviousStep = _ref.goToAPreviousStep,
    _ref$raised = _ref.raised,
    raised = _ref$raised === void 0 ? false : _ref$raised;
  return /* @__PURE__ */React.createElement(TransitionGroup, {
    className: classNames("step-count", {
      "step-count--raised": raised
    })
  }, new Array(totalSteps).fill(0).map(function (_, index) {
    return /* @__PURE__ */React.createElement(CSSTransition, {
      classNames: "step-count__step",
      timeout: 500,
      key: "step--".concat(index)
    }, /* @__PURE__ */React.createElement("div", {
      className: "step-count__step-wrapper"
    }, index !== 0 && /* @__PURE__ */React.createElement("div", {
      key: "line--".concat(index),
      className: "step-count__line"
    }), /* @__PURE__ */React.createElement("div", {
      className: classNames("step-count__step", {
        "step-count__step--current": index === currentStep,
        "step-count__step--previous": index < currentStep
      }),
      onClick: function onClick() {
        if (index < currentStep) {
          goToAPreviousStep(index);
        }
      }
    }, index === currentStep && index + 1)));
  }));
});